/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Title, Tip, Icon, Switch, Note, TextField } from '@insticator/insticator-ui'; // iui-material
import ImageUpload from 'material/imageupload/imageupload_container';
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties_styles';



/* ========== ~~~~~~~~~~ EMBED PROPERTIES ~~~~~~~~~~ ========== */
class EmbedProperties extends Component {
	constructor(props) {
		super(props);
		this.state = { partnerurl: true };
		this.setPartnerLogoSrc = this.setPartnerLogoSrc.bind(this);
		this.validateURL = this.validateURL.bind(this);
		this.setBrandColor = this.setBrandColor.bind(this);
		this.processInput = this.processInput.bind(this);
		this.setPartnerLogoPreview = this.setPartnerLogoPreview.bind(this);
		this.handleLogoToggle = this.handleLogoToggle.bind(this);
	}
	componentDidMount() {
		if (this.props.partnerLogo.url !== null) {
			this.validateURL(this.props.partnerLogo.url);
		}
	}
	processInput(e) {
		this.validateURL(e.target.value);
		if (this.isValid(e.target.value)) {
			this.props.setPartnerLogoUrl(e.target.value)
		}
	}
	validateURL(url) {
		this.setState({ partnerurl: this.isValid(url) });
	}
	isValid(data) {
		return /^(|https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?)$/.test(data);
	}
	setPartnerLogoPreview(imageFile) {
		this.props.setPartnerLogoSrc(imageFile);
	}
	setPartnerLogoSrc(imageFile) {
		// this.props.setPartnerLogoSrc(URL.createObjectURL(imageFile));
		this.props.updatePartnerLogo(this.props.accountUUID, imageFile);
	}
	setBrandColor(color) {
		this.props.setEmbedProperty('brandColor', color);
	}
	handleLogoToggle() {
		this.props.toggleShowPartnerLogo(!this.props.showPartnerLogo);
	}
	showPlacement = () => this.props.location === 'in-content' ? 'incontent' : 'rail';
	render() {
		return (
			<div className={`embedproperties ${this.props.classes.embedproperties} ${this.showPlacement()}`}>
				<Note>
					<p><span>Embed branding is applied </span>across all screens.</p>
				</Note>
				<div className={`property partnerlogo`}>
					<div className={`proptitle`}>
						<div className={`titleToggle`}>
							<h5>Logo <Tip space={`left`} content={`Recommended to use transparent image or PNG file for logo branding`} /></h5>
							<Switch handleClick={this.handleLogoToggle} value={null} on={this.props.showPartnerLogo ? 'on' : 'off'} variant={'secondary'} />
						</div>
					</div>
					<div className={`propdetails ${!this.props.showPartnerLogo ? `noPartnerLogo` : null}`}>
						<div className={`propdetail image`}>
							<ImageUpload previewImage={this.setPartnerLogoPreview} processImage={this.setPartnerLogoSrc} cta={true} uploadingCustomImage={this.props.uploadingCustomImage}  imageSize={{ width: '200px', height: 'auto' }} cropSize={{ width: 275, height: 96 }} zoomRange={{ min: 0.25 }} isLogoCropper={true} />
						</div>
					</div>
					<div className={`proptitle`}>
						<div className={`titleToggle`}>
							<h5>Click-through URL</h5>
						</div>
					</div>
					<div className={`propdetails ${!this.props.showPartnerLogo ? `noPartnerLogo` : null}`}>
						<div className={`propdetail link`}>
							<TextField type={`url`} name={`partnerurl`} valid={!!this.state.partnerurl} placeholder={this.props.partnerLogo.url === null ? `ex http://www.xyz.com` : ``} handleChange={this.processInput} defaultValue={this.props.partnerLogo.url === null ? `` : this.props.partnerLogo.url}  icon={<Icon name={`link`} />}/>
						</div>
					</div>
				</div>
				<div className={`property brandcolor`}>
					<div className={`proptitle`}>
						<h5>Brand Color <Tip space={`left`} content={`Buttons, progress bars, result bars, and other visual elements will utilize this color to give your embed a more branded appearance.`} /></h5>
					</div>
					<div className={`propdetails`}>
						<div className={`propdetail color`}>
							<ColorPicker color={this.props.brandColor} processColorUpdate={this.setBrandColor} />
						</div>
					</div>
				</div>
				{!!this.props.mocked && <div className={`property insticatorbranding`}>
					<div className={'togglelabel'}>COOL Media brand tag <Tip space={`left`} content={`Includes the “Powered by COOL Media text and logo.`} /></div>
					<Switch handleClick={this.props.toggleInsticatorBranding} value={null} on={this.props.showInsticatorBranding ? 'on' : 'off'} variant={'secondary'} />
				</div>}
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedProperties);
